import React from 'react';
import aboutPhoto from '../../images/carter-united-nations-youth-envoy.jpg';

const HomeAbout = () => (
  <div className="section section-about" id="about">
    <div className="section-wrapper-main">
      <div className="card">
        <div className="card-image">
          <img src={aboutPhoto} />
        </div>
        <div className="card-content mobile-hide">
          <h1>My Name is Carter Ries...</h1>
          <p>
            and I am a 17 year old student at Fayette County High in my senior year. For the past nine almost ten years, I have been co-running a non-profit organization called ​One More Generation with my sister. I have traveled throughout the U.S. and to over 10 countries around the world educating people about various issues facing this planet and the need for all of us to get involved with being the solution. In my spare time, I like to draw, and play piano along with playing goalkeeper for my varsity soccer team at my school. I have been working for Starbucks for almost two years and have enjoyed it greatly. I am also a certified lifeguard which I do during the summer months.
          </p>
          <p>
            I have a passion for education, a passion for the environment, and a passion to work together to help others. I am confident in my abilities to produce great results no matter the situation, and I always strive for success. I will always be an advocate for the planet no matter what I do. I hope to learn more about how climate change is affecting our planet and ways that I can get involved in finding solutions.  My interests also involve finance, business, and economics and I hope to work in one of those fields after graduating college. Wherever my career takes me, I plan to keep environmental concerns in the forefront of my life.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default HomeAbout;
